<template>
  <span>{{text}}</span>
</template>

<script>
export default {
  props: ['event'],
  computed: {
    text () {
      let result = ''
      if (this.event === 'grant') {
        result = 'Sucesso'
      } else if (this.event === 'deny') {
        result = 'Rejeitado'
      } else if (this.event === 'reopen') {
        result = 'Reaberto'
      } else if (this.event === 'revert') {
        result = 'Revertido'
      } else if (this.event === 'processing') {
        result = 'Processamento'
      } else if (this.event === 'note') {
        result = 'Comentário'
      } else if (this.event === 'edit') {
        result = 'Edição'
      }
      return result
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// CommentEvent.vue?386f7752